module.exports = __webpack_public_path__ + "5d5062d93b5d031e6cf2b8f609031200.svg";